<template>
    <div class="container">
        <div class="title">
            <div class="title-text">
                <span>发布商品</span>
            </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <div class="form-label-title">基本信息</div>
            <el-form-item label="商品类型" prop="spuType">
                <el-radio-group v-model="form.spuType" :disabled="disabled" >
                    <el-radio v-for="item in spuTypeList" :key="item.name" :label="item.id">{{item.name}}</el-radio>
                </el-radio-group>
                <el-popover
                    placement="top"
                    trigger="hover"
                    content="直播商品仅可在直播间使用，不在其他场景下分发">
                    <span slot="reference">
                        <i class="el-icon-question"></i>
                    </span>
                </el-popover>
            </el-form-item>
            <el-form-item label="商品分类" prop="caArr" v-if="!this.spuId">
                <el-cascader
                    v-model="form.caArr"
                    :props="props"
                    @change="cascaderChange">
                </el-cascader>
            </el-form-item>
            <el-form-item label="商品分类" prop="categoryId" v-else>
                <el-input v-model="cascaderValue" :disabled="disabled"  style="width: 500px"></el-input>
            </el-form-item>
            <el-form-item label="商品名称" prop="name">
                <el-input
                    v-model="form.name"
                    required="true"
                    :clearable="true"
                    maxlength="60"
                    show-word-limit
                    placeholder="请输入商品名称"
                    style="width: 500px"
                ></el-input>
            </el-form-item>
            <el-form-item label="商品副标题" prop="subTitle" v-if="isNormalType">
                <el-input
                    v-model="form.subTitle"
                    :clearable="true"
                    maxlength="120"
                    show-word-limit
                    placeholder="请输入商品副标题"
                    style="width: 500px"
                ></el-input>
            </el-form-item>
            <el-form-item label="平台属性" prop="propertyList"  v-if="isNormalType">
                <div v-if="Array.isArray(propertyList) && propertyList.length" class="auto-property">
                    <span>请标准填写属性，有利于商品在搜索和推荐中露出，错误填写可能会面临流量损失。</span>
                    <div v-for="(propertyItem, propertyIndex) in propertyList" :key="propertyItem.propertyName + propertyIndex">
                        <span>
                            <!-- requiredFlag 0-必填 1-非必填 -->
                            <span :class="!propertyItem.requiredFlag ? 'attr-name label-width-red-dot' : 'attr-name'">{{propertyItem.propertyName}}</span>
                            <el-select v-if="propertyItem.propertyValues" v-model="propertyList[propertyIndex].propertyValue" :clearable="true" placeholder="请选择">
                                <el-option
                                    v-for="(item, index) in propertyItem.propertyValues.split('|')"
                                    v-if="item"
                                    :key="item + index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                            <el-input v-else v-model="propertyList[propertyIndex].propertyValue" placeholder="请输入" maxlength="20" show-word-limit clearable></el-input>
                        </span>
                    </div>
                    <span v-if="propertynNoValueFlag" class="no-platform-attr">暂无平台自定义属性信息</span>
                </div>
                <span v-else class="no-platform-attr">暂无平台自定义属性信息</span>
            </el-form-item>
            <el-form-item label="商家自定义属性" prop="merchantProperty" v-if="isNormalType">
                <div v-for="(item, index) in form.merchantProperty" class="sku-attr-wrap">
                    <span class="delete" @click="delMerchantProperty(index)">&times</span>
                    <label class="el-form-item-value">属性名</label>
                    <el-input v-model="form.merchantProperty[index].propertyName" placeholder="请输入内容"></el-input>
                    <label class="el-form-item-value">属性值</label>
                    <el-input v-model="form.merchantProperty[index].propertyValue" placeholder="请输入内容"></el-input>
                </div>
                <P class="addMerchantProperty" href="javascript:;" @click="addMerchantProperty">+新增商家自定义属性</P>
            </el-form-item>

            <div class="form-label-title"  v-if="isNormalType">销售信息</div>
            <el-form-item label="商品规格" prop="standardList" v-if="isNormalType">
                <P class="addMerchantProperty" href="javascript:;" @click="addStandardList" v-if="form.standardList.length < 2">+新增商品规格</P>
                <div v-for="(item, index) in form.standardList" :key="item.row">
                    <div>
                      <div class="form-item-row-inline">
                        <span class="delete" @click="delMerchantStard(index)">&times</span>
                            <label class="el-form-item-value">规格名</label>
                        <div>
                            <!--@TODO:确定属性值来源-->
                            <el-select v-model="item.row" placeholder="请选择">
                                <el-option
                                    v-for="itemselect in remoteStandardList"
                                    :disabled="itemselect.disabled"
                                    :key="itemselect.standardName"
                                    :label="itemselect.standardName"
                                    :value="itemselect.standardName">
                                </el-option>
                            </el-select>
                        </div>
                      </div>
                  </div>
                    <label class="el-form-item-value">规格值</label>
                    <div class="form-item-row">
                        <div class="form-item-row-inline" v-for="(standardObj, valueIndex) in item.standardValues">
                          <el-input v-model="standardObj.standardValue" placeholder="请输入规格值" @change="handleStandardNameChange($event)"></el-input>
                          <span class="delete" @click="delMerchantStardValue(index, valueIndex)">&times</span>
                          <div class="form-item-row">
                              <div class="standard-image-wrap" v-if="standardObj.img">
                                <img :src="standardObj.img">
                                <div class="delete-icon" @click="handleRemoveStandard(standardObj)">&times</div>
                              </div>
                              <el-upload
                                  v-else
                                  :action="UploadURL"
                                  list-type="picture-card"
                                  name="imgFile"
                                  :show-file-list="false"
                                  :limit="1"
                                  :file-list="standardObj.img ? [{url: standardObj.img}] : []"
                                  :before-upload="beforeAvatarUpload"
                                  :on-success="handleSuccessStandard.bind(this, standardObj)"
                                  :on-preview="handlePreview"
                                  :on-exceed="handleExceedStandard.bind(this, standardObj)"
                                  :on-error="handleError">
                                  <i class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                              
                          </div>
                        </div>
                    </div>
                    <P class="addMerchantProperty" href="javascript:;" @click="addStandardListValue(index)">+新增商品规值</P>
                </div>
                <el-table
                    :data="standardListData"
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        v-for="item in StandardListFilter"
                        :key="item.standardName"
                        :prop="item.standardName"
                        :label="item.standardName">
                    </el-table-column>
                    <el-table-column
                        prop="stockNum"
                        label-class-name="label-width-red-dot"
                        label="库存"
                        key="standardStockNum">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.stockNum" placeholder=""></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="marketPrice"
                        label="原价(元)"
                        key="standardMarketPrice">
                        <template slot-scope="props">
                            <el-input v-model="props.row.marketPrice" placeholder=""></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="salePrice"
                        label-class-name="label-width-red-dot"
                        label="单价(元)"
                        key="standardSalePrice">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.salePrice" placeholder=""></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="outerSkuId"
                        label="sku编码"
                        key="standardOuterSkuId"
                    >
                        <!-- :render-header="renderHeader" -->
                        <!-- <span slot="label">
                            <i class="el-icon-question"></i>sku编码
                        </span> -->
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.outerSkuId" placeholder=""></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!!StandardListFilter.length"
                        key="standardHeadPics"
                        prop="headPics"
                        label-class-name="label-width-red-dot"
                        label="预览图">
                        <template slot-scope="scope">
                            <el-image
                                v-if="scope.row.headPics"
                                style="width: 100px; height: 100px"
                                :src="scope.row.headPics"
                                :preview-src-list="[scope.row.headPics]"
                            >
                            </el-image>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!!StandardListFilter.length"
                        key="standardDisplayFlag"
                        prop="displayFlag"
                        label="是否展示">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.displayFlag"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                            </el-switch>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>

            <div class="form-label-title"  v-if="isNormalType">图文信息</div>

            <el-form-item label="商品图" prop="headPics">
                <el-upload
                    :action="UploadURL"
                    list-type="picture-card"
                    name="imgFile"
                    :limit="9"
                    :file-list="fileList"
                    :before-upload="beforeAvatarUpload.bind(this, [600, 600])"
                    :on-preview="handlePreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                    :on-exceed="handleExceed"
                    :on-error="handleError">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <div class="img-upload-tip">
                    <p>说明：商品轮播图</p>
                    <p>a. 尺寸宽高需均大于600*600px</p>
                    <p>b. 大小10M以内</p>
                    <p>c. 数量限制在9张以内</p>
                    <p>d. 图片格式仅支持JPG,JPEG,PNG格式</p>
                    <p>f. 可以拖动改变图片顺序</p>
                </div>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
			<el-form-item label="商品详情" prop="detailInfo"  v-if="isNormalType">
                <quill-editor
                    v-model="content"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @change="onEditorChange($event)">
                </quill-editor>
                <el-upload
                    id="iviewUp"
                    v-show="false"
                    :action="UploadURL"
                    :before-upload="beforeAvatarUpload"
                    :show-file-list="false"
                    list-type="picture-card"
                    name="imgFile"
                    :on-success="handleSuccessQuill">
                </el-upload>
            </el-form-item>
            <el-form-item label="价格" prop="marketPriceValue" v-if="isLiveType">
                <div>
                    <el-input-number v-model="form.marketPriceValue" size="large" :precision="2" :max="10000000" :step="0.1"></el-input-number>
                    <span class="el-form-item-value price-right"> 元</span>
                </div>
            </el-form-item>
            <el-form-item label="库存" prop="primaryStock" v-if="isLiveType">
                <el-input-number class="primaryStock" v-model="form.primaryStock" label="描述文字" ></el-input-number>
            </el-form-item>
            <el-form-item>
                <div class="button-wrapper">
                    <el-button  @click="onClickBtn('form', 'createSpu')" v-if="!spuId">保存草稿</el-button>
                    <el-button type="primary" @click="onClickBtn('form', 'submitSpu')">发布</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import Quill from 'quill';
let Align = Quill.import('attributors/style/align');
Quill.register(Align, true);
let toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    ['image'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['clean']
];
// 商品类型list
const SpuTypeId = [0, 1];
const SpuTypeList = [{
    id: SpuTypeId[0],
    name: '普通商品'
}, {
    id: SpuTypeId[1],
    name: '直播商品'
}];
const UploadURL = location.hostname === "zcm.baidu.com" ? '/platform/interface/uploadimg' : '/interface/uploadimg';
import {
    quillEditor
}  from 'vue-quill-editor';
import getImageRect from '../../utils/getImageRect';

export default {
    components: {
        quillEditor
    },
    computed: {
        'StandardListFilter': function() {
            return this.form.standardList.filter(item => !!item.standardName);
        }
    },
    data() {
        return {
            UploadURL,
            isNormalType: true,
            isLiveType: false,
            disabled: false,
            spuTypeList: SpuTypeList,
            // 商品属性列表
            propertyList: [],
            propertynNoValueFlag: false,
            dialogVisible: false,
            dialogImageUrl: '',
            fileList: [],
            // [   {   name: 'food.jpeg',
            //         url: 'https://100'
            //     },
            //     {   name: 'food.jpeg',
            //         url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
            //     },
            //     {   name: 'food2.jpeg',
            //         url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bceuality/100'}],
            form: {
                spuType: SpuTypeId[0],
                name: '', // 商品名称
                subTitle: '', // 商品副标题
                detailInfo: '', // 商品详情
                headPics: [], // 头图列表
                standardList: [],
                marketPriceValue: 0, // 市场价
                skuId: '',
                salePriceValue: 0,
                platformProperty: [],  // 平台自定义属性
                merchantProperty:[], // 商家自定义属性
                primaryStock: 0, // 库存数量
                caArr: [],
                standardInfo: [ // 规格
                    {
                        standardCode: '',
                        standardName: '',
                        standardValues: '',
                        masterFlag: 1,
                    }
                ]
            },
            remoteStandardList: [],
            editor: null,   // 富文本编辑器对象
            content: '', // 富文本编辑器默认内容
            editorOption: {
                placeholder: '',
                // or 'bubble'
                theme: 'snow',
                modules: {
                    toolbar: {
                        // 工具栏
                        container: toolbarOptions,
                        handlers: {
                            image(value) {
                                if (value) {
                                    document.querySelector('#iviewUp input').click();
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },
            spuId: this.$route.query.spuid || '',
            standardListFromServerFlag: false,
            // 校验
            rules: {
                spuType: [
                    {required: true, message: '请选择商品类型', trigger: 'blur'}
                ],
                caArr: [
                    {required: true, validator: (rule, value, callback) => { if (!value[0]) { callback(new Error('请选择商品分类')) } else { callback() } }, message: '请选择商品分类', trigger: 'change'}
                ],
                name: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'}
                ],
                headPics: [
                    {required: true, message: '请至少上传一张商品图', trigger: 'onchang'}
                ],
                detailInfo: [
                    {required: true, message: '请填写商品详情', trigger: 'onchange'}
                ],
                marketPriceValue: [
                    {required: true, type: 'number', message: '请填写价格', trigger: 'blur'},
                    { type: 'number', min: 0.01, max: 10000000, message: '请填写价格0'}
                ],
                primaryStock: [
                    {required: true, type: 'number', message: '请输入库存数量', trigger: 'blur'},
                    {type: 'number', min: 1, max: 10000000, message: '请输入库存数量'}
                ],
                // 校验规则信息: 规则值必填, 价格等必填 所填值需要是数字类型
                standardList: [
                    {
                        required: true, trigger: 'blur',
                        validator: (rule, value, callback) => {
                            let errFlag = false;
                            // standardItem: [{
                            //     disabled: true
                            //     row: "规格颜色0720"
                            //     standardCode: "standardcolor0720"
                            //     standardId: 1000171
                            //     standardName: "规格颜色0720"
                            //     standardValues: [{img: '', standardValue: "red"}]
                            // }]
                            // 价格 库存等必填
                            this.standardListData.map(itemData => {
                                if (!(+itemData.stockNum >= 0 && +itemData.salePrice >= 0.01)) {
                                    callback(new Error('请填写正确的价格和库存（价格最少0.01元）'));
                                    errFlag = true;
                                    return;
                                }
                            });
                            value.map(standardItem => {
                                const standardValues = standardItem.standardValues;
                                // 规格值为必填
                                if (standardItem.standardName && !standardValues.length) {
                                    callback(new Error('规格值为必填'));
                                    errFlag = true;
                                    return;
                                }
                                // 规格值和图片必填
                                Array.isArray(standardValues) && standardValues.map(standardValueItem => {
                                    // if (!standardValueItem.standardValue) {
                                    if (!standardValueItem.standardValue || !standardValueItem.img) {
                                        callback(new Error('规格值和图片为必填'));
                                        errFlag = true;
                                        return;
                                    }
                                });
                            });
                            if (!errFlag) {
                                callback();
                            }
                        }
                    }
                ],
                
            },
            salePriceError: false,
            standardData: [],
            // 级联选择器的展示
            cascaderValue: '',
            // 级联选择器的列表获取
            props: {
                lazy: true,
                lazyLoad: (node, resolve) => {
                    if (this.spuId) {
                        return;
                    }
                    const {value} = node;
                    let params = Object.assign({
                        parentId: value || 0
                    }, {
                        platformId: 436537610,
                        merchantId: 0,
                        operator: 'admin'
                    });
                    // 获取类目列表
                    this.$api.getNoPageCategoryList(params).then(res => {
                        if (+res.code !== 0) {
                            this.$notify({
                                title: '提示',
                                message: res.msg
                            });
                            return;
                        }
                        let categoryTree = res.data.categoryTree || [];
                        let cascaderOption = [];
                        categoryTree.forEach(val => {
                            cascaderOption.push({
                                value: val.categoryId,
                                label: val.categoryName,
                                leaf: !val.leaf
                            });
                        });
                        resolve(cascaderOption);
                    });
                }
            },
        };
    },
    watch: {
        '$route'(to, from) {
            if (!to.query.spuid && from.query.spuid) {
                location.reload();
            }
        },
        // 监听standardList 如果已经选中，下次select需要禁掉，避免重复
        'form.standardList': {
            deep: true,
            immediate: true,
            handler(newVal) {
                // 改变自身的值
                newVal.forEach((item, index) => {
                    if (item.row) {
                        this.remoteStandardList.forEach(item2 => {
                            if (item.row === item2.standardName) {
                                item = Object.assign(item, item2);
                                item2.disabled = true;
                            }
                        })
                    }
                });
                // 改变standardListdata
                // 如果是回填数据，则不许处理
                if (this.standardListFromServerFlag) {
                    this.standardListFromServerFlag = false;
                    return;
                }
                // 手动操作处理
                // @TODO: 待优化 用笛卡尔积
                const [standard1 = {}, standard2 = {}] = newVal;
                const stdVal1 = standard1.standardValues || [];
                const stdVal2 = standard2.standardValues || [];

                let data = [];
                const originObj = {
                    outerSkuId: '',
                    stockNum: 0,
                    salePrice: 0,
                    marketPrice: 0,
                    // headPics: '',
                    displayFlag: 1,
                };
                for (let i = 0; i < stdVal1.length; i++) {
                    const obj = Object.assign({}, originObj);
                    if (stdVal2.length) {
                        for (let j = 0; j < stdVal2.length; j++) {
                            if (standard1.standardName) {
                                obj[standard1.standardName] = stdVal1[i].standardValue;
                                obj['headPics'] = stdVal1[i].img;
                            }
                            if (standard2.standardName) {
                                obj[standard2.standardName] = stdVal2[j].standardValue;
                                obj['headPics'] = stdVal2[j].img;
                            }

                            data.push({...obj});
                        }
                    } else {
                        if (standard1.standardName) {
                            obj[standard1.standardName] = stdVal1[i].standardValue;
                            obj['headPics'] = stdVal1[i].img;
                        }
                        data.push(obj);
                    }
                }
                // 没有数据默认展示一条
                if (!data.length) {
                    data.push(originObj);
                }

                this.standardListData = data;

            }
        },
        // 切换商品类型
        'form.spuType': function(val) {
            this.isNormalType = val === SpuTypeId[0];
            this.isLiveType = val === SpuTypeId[1];
            // 清空校验
            this.$refs.form.clearValidate();
        }
    },
    mounted() {
        if (this.spuId) {
            // 修改spu, 获取信息内容
            this.getSpuInfo();
        }
        window.onbeforeunload = function (e) {
            e = e || window.event;
            // 兼容IE8和Firefox 4之前的版本
            if (e) {
                e.returnValue = '关闭提示';
            }
            // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
            return '关闭提示';
        };
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            window.scrollTo(0, 0);
        });
    },
    beforeDestroy() {
        this.editor = null;
        delete this.editor;
    },
    methods: {
        handleStandardNameChange(value) {
            let count = 0;
            this.form.standardList.forEach(standard => {
                standard.standardValues.forEach(standardValue => {
                    if (standardValue.standardValue === value) {
                        count++;
                    }
                });
            })
            if (count >= 2) {
                this.$message({
                    message: '规格值不能重复！',
                    type: 'warning'
                });
            }
        },
        // 渲染自定义的表头
        renderHeader(h, {column}) {
            return h(
                'div',
                [ 
                    h('span', column.label),
                    h('el-tooltip',{
                        props: {
                            content: '商品编码是为了方便商家管理商品，用于库存管理，多渠道销售分析等；商家可以在这里输入erp编码，库存编号，标准条码等；对于多规格的商品，可以设置整个商品的编码和每个规格(SKU)的编码；商品编码需要商品发布成功才能生效。',
                            placement: 'top'
                        }
                    }, [
                        h('i', {
                            class:'el-icon-question',
                            style:'color:#409eff;margin-left:5px;'
                        })
                    ])
                ],
            );
        },
         // 商品分类: 级联选择器节点发生变化
        cascaderChange(value) {
            this.caArr = value;
            this.form.categoryId = value[value.length - 1];
            // 获取平台属性
            this.getAttrList();
            // 获取规格选项
            this.getRemoteStandardList();
        },
        //笛卡儿积组合
        descartes(list, callback) {
            //parent上一级索引;count指针计数
            var point = {};
            var result = [];
            var pIndex = null;
            var tempCount = 0;
            var temp = [];
            //根据参数列生成指针对象
            for (var index in list) {
                if (typeof list[index] == 'object') {
                point[index] = {
                    'parent': pIndex,
                    'count': 0
                }
                pIndex = index;
                }
            }
            //单维度数据结构直接返回
            if (pIndex == null) {
                return list;
            }
            //动态生成笛卡尔积
            while (true) {
                for (var index in list) {
                    tempCount = point[index]['count'];
                    temp.push(list[index][tempCount]);
                }
                //压入结果数组
                temp = callback && callback(temp);
                result.push(temp);
                temp = [];
                //检查指针最大值问题
                while (true) {
                    if (point[index]['count'] + 1 >= list[index].length) {
                        point[index]['count'] = 0;
                        pIndex = point[index]['parent'];
                        if (pIndex == null) {
                        return result;
                        }
                        //赋值parent进行再次检查
                        index = pIndex;
                    } else {
                        point[index]['count']++;
                        break;
                    }
                }
            }
        },
        // 图片上传前的格式+大小校验
        beforeAvatarUpload(minScale = [], file) {
            // 处理不传参的情况
            if (minScale instanceof File) {
                file = minScale;
                minScale = [];
            }

            if (!file) { return false; }
            const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png'); //  || file.type === 'image/bmp'
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传图片只能是jpg/jpeg/png格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 10MB!');
                return false;
            }
            if (minScale.length !== 2) {
                return true;
            }
            return new Promise((resolve, reject) => {
                getImageRect([file]).then(res => {
                    let file = res[0];
                    if (minScale[0] > file.width || minScale[1] > file.height) {
                        this.$message.error(`上传图片最小${minScale[0]} x ${minScale[1]}px!`);
                        reject(file);
                    } else {
                        resolve(file);
                    }
                }).catch(err=>{
                    file.warn = err;
                    resolve(file);
                });
            });
        },
        delMerchantProperty(index) {
            this.form.merchantProperty.splice(index, 1);
        },
        delMerchantStard(index) {
            this.$confirm('删除规格时，如右图弹框提示：删除该规格后，当前的规格相关数据将丢失，确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.remoteStandardList.map(item2 => {
                    if (this.form.standardList[index].standardName === item2.standardName) {
                        item2.disabled = false;
                    }
                });
                this.form.standardList.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            })
        },
        handleFocusStandardSelect(val) {
            this.remoteStandardList.map(optionsItem => {
                this.form.standardList.map(selectItem => {
                    if (optionsItem.standardName === selectItem.standardName) {
                        optionsItem.disabled = true;
                    }
                })
            });
        },
        addMerchantProperty() {
            if (this.form.merchantProperty.length >= 10) {
                return;
            }
            this.form.merchantProperty.push(
                {
                    propertyName: '',
                    propertyValue: ''
                }
            );
        },
        // 创建-获取属性列表
        getAttrList() {
            // commonParams
            this.$api.getCategoryAttrList({
                categoryId: this.form.categoryId
            }).then(res => {
                if (+res.code !== 0) {
                    this.$notify({
                        title: '提示',
                        message: res.msg
                    });
                    return;
                }
                this.propertyList = res.data;
                if (Array.isArray(this.propertyList)) {
                    this.propertyList.forEach(val => {
                        this.$set(val, 'propertyValue', '');
                    });
                }
            }).catch(err => {
                console.log(err);
            });
        },
        // 添加规格名
        addStandardList() {
            if (this.form.standardList.length >= 5) {
                return;
            }
            this.form.standardList.push(
                {
                    standardId: '',
                    standardCode: '',
                    standardName: '',
                    // standardValue: '', // @TODO: 服务端接受格式。下面要改改
                    standardValues: [{
                        standardValue: '',
                        img: ''
                    }]
                }
            );
        },
        // 往对应的规格里面添加值
        addStandardListValue(index) {
            this.form.standardList[index].standardValues.push({
                standardValue: '',
                img: ''
                // img: 'https://pics2.baidu.com/feed/03087bf40ad162d9d8f545d0fc2655ea8813cde7.jpeg?token=1f5b6d418c6ff5ca7467e3d26ff9ea69'
            });
        },
        delMerchantStardValue(index, valueIndex) {
            if (!this.form.standardList[index] || !this.form.standardList[index].standardValues) {
                return;
            }
            this.form.standardList[index].standardValues.splice(valueIndex, 1);
        },
        // 获取spu信息
        async getSpuInfo() {
            this.$api.getSpuInfo({id: this.spuId}).then(res => {
                console.log(res);
                if (+res.code !== 0 || !res.data) {
                    this.$notify({
                        title: '提示',
                        message: res.msg
                    });
                    return;
                }
                // 禁用组件
                this.disabled = true;
                /*
                    skuInfo数据处理，listdata的数据trans为后端需要的
                */
                this.spuInfoList = res.data;
                const {spuType, categoryId, categoryList, name, subTitle, headPics, detailInfo, platformProperty, merchantProperty} = this.spuInfoList;
                // 获取商品类型
                this.form.spuType = spuType;
                // 获取商品分类及相关
                let cascaderArr = [];
                categoryList.forEach(val => {
                    cascaderArr.push(val.categoryName);
                });
                this.form.categoryId = categoryId;
                this.cascaderValue = cascaderArr.join('/');
                // 获取商品名称
                this.form.name = name;
                // 获取副标题
                this.form.subTitle = subTitle;
                // 对负责头图列表展示的数组进行初始化处理
                this.form.headPics = headPics;
                headPics.forEach(val => this.fileList.push({ url: val }));
                // 获取富文本编辑器列表
                this.content = detailInfo;
                this.form.detailInfo = detailInfo;
                // 获取平台自定义属性列表
                this.propertyList = platformProperty;
                // let propertyflagArr = [];
                if (this.propertyList.length) {
                    this.propertyList.forEach(val => {
                        // 如果有一项的propertyValue有值，propertynNoValueFlag为false
                        if (val.propertyValue || val.propertyValue === 0) {
                            this.propertynNoValueFlag = false;
                        }
                    });
                }
                // // 平台自定义属性列表每一项propertyValue都没有值
                // if (propertyflagArr.indexOf('hasValue') === -1) {
                //     // 则html展示暂无平台自定义属性
                //     this.propertynNoValueFlag = true;
                // }
                // 获取商家自定义属性列表
                this.form.merchantProperty = merchantProperty;

                // 获取规格相关数据
                this.getRemoteStandardList();
                const {standardInfo = [], skuList = []} = res.data || {};
                const standardListData = [];
                // 对后端传过来的数据做处理--商品规格
                /*
                    standardInfo数据处理, trans成前端需要的standardList
                    要的[{"standardCode":"color","standardName":"颜色","standardValues":"红色|蓝色","standardValues":[红色,蓝色],"maserFlag":0},{"standardCode":"size","standardName":"尺寸","standardValues":"40","maserFlag":1}];
                */
                this.form.standardList = this.serverTransData(standardInfo);
                this.standardListFromServerFlag = true;
                this.form.standardList.forEach(itemData => {
                    itemData.row = itemData.standardName;
                });

                if (+spuType === 0) {
                    // 对后端传过来的数据做处理--商品规格-详细信息
                    skuList.forEach(itemSku => {
                        const standardObj = {};
                        /* 将后端数据处理为前端需要的数据
                            itemSku.standardList:[{
                                masterFlag: 0
                                standardCode: "color0718"
                                standardId: 1000153
                                standardName: "颜色0718"
                                standardValue: "red\"
                            }]
                            standardObj: {颜色0718: "red\"}
                        */
                        itemSku.standardList.forEach(itemObj => standardObj[itemObj.standardName] = itemObj.standardValue);
                        // standardListData 数据处理
                        standardListData.push({
                            skuId: itemSku.skuId,
                            outerSkuId: itemSku.outerSkuId,
                            stockNum: itemSku.stockNum,
                            salePrice: (Number(itemSku.salePrice) / 100).toFixed(2),
                            marketPrice: itemSku.marketPrice.toString() ? (Number(itemSku.marketPrice) / 100).toFixed(2) : '',
                            displayFlag: !!itemSku.displayFlag,
                            headPics: itemSku.headPics,
                            ...standardObj
                        });
                    });
                    this.standardListData = standardListData;
                }

                if (+spuType === 1 && skuList[0]) {
                    // 直播的价格
                    this.form.marketPriceValue = Number(skuList[0].salePrice) / 100; // 后端传过来的是分
                    // 直播的库存
                    this.form.primaryStock = Number(skuList[0].stockNum);
                }
            }).catch(err => {
                console.log('获取spu信息', err);
            });
        },
        getData() {
            for (let p in this.form) {
                if (typeof this.form[p] === 'string') {
                    this.form[p] = this.form[p].trim();
                }
            }
            let validate = true;
            this.$refs.form.validate(valid => !!valid);
            let formparam = Object.assign({}, this.form);
            // spuid
            formparam.spuId = this.spuId;
            // 规格信息
            // 测试数据

            /*
                standardInfo数据处理, trans成后端需要的
                要的[{"standardCode":"color","standardName":"颜色","standardValues":[{standardValue: '红色', img: ''},[]]"红色|蓝色","maserFlag":0},{"standardCode":"size","standardName":"尺寸","standardValues":"40","maserFlag":1}];
            */
            formparam.standardInfo = formparam.standardList.map((itemInfo, index) => ({
                ...itemInfo,
                standardValues: itemInfo.standardValues.map(item => item.standardValue).join('|'),
                // standardValues: itemInfo.standardValues.map(item => item.standardValue),
                masterFlag: index
            }));
            /*
                skuInfo数据处理，listdata的数据trans为后端需要的
                我们的数据：[{颜色: 红色}], 后端要的[{standardName: '颜色', standardValue: '红色'}]
            */
            formparam.skuInfo = this.standardListData.map((itemData, index) => {
                const numPriceData = Object.assign({}, itemData);

                // 价格等的处理 价格做转化 元 -> 分 给后端分
                numPriceData.salePrice = (Number(numPriceData.salePrice) * 100).toFixed();
                numPriceData.marketPrice = numPriceData.marketPrice.toString() ? (Number(numPriceData.marketPrice) * 100).toFixed() : '';
                numPriceData.stockNum = Number(numPriceData.stockNum);
                numPriceData.displayFlag = +numPriceData.displayFlag;

                let transtoserver = () => {
                    if (!formparam.standardInfo.length) {
                        return [];
                    }
                    // standardList
                    let resultStandardList = [];
                    Object.keys(numPriceData).forEach(key => {
                        formparam.standardInfo.map(item => {
                            if(item.standardName === key) {
                                resultStandardList.push({
                                    ...item,
                                    standardValue: numPriceData[key]
                                });
                            }
                        })
                    });
                    // 删除些没用的属性
                    resultStandardList.forEach(itemstandard => {
                        delete itemstandard.standardValues;
                        delete itemstandard.row;
                        delete itemstandard.disabled;
                    });
                    return resultStandardList;
                }
                return {
                    ...numPriceData,
                    standardList: transtoserver()
                }
            });
            // 商品属性(平台属性)
            formparam.platformProperty = JSON.stringify(this.propertyList);
            // 商家自定义属性
            formparam.merchantProperty = JSON.stringify(formparam.merchantProperty);
            // 商品图/头图
            formparam.headPics = []
            this.fileList.forEach((item, index) => {
                formparam.headPics.push(item.url);
            });
            formparam.headPics = JSON.stringify(formparam.headPics);

            // 不可修改元素
            let cantChange = this.spuId ? {} : {
                categoryId: formparam.categoryId // 分类
            };
            // 普通商品
            if (this.isNormalType) {
                return {
                    spuType: formparam.spuType, // 商品类型
                    categoryId: formparam.categoryId, // 分类
                    name: formparam.name, // 名称
                    subTitle: formparam.subTitle, // 副标题
                    platformProperty: formparam.platformProperty, // 商品属性
                    merchantProperty: formparam.merchantProperty, // 自定属性
                    headPics: formparam.headPics, // 商品图
                    detailInfo: formparam.detailInfo, // 商品描述
                    standardInfo: JSON.stringify(formparam.standardInfo),
                    skuInfo: JSON.stringify(formparam.skuInfo),
                    // 规格
                    ...cantChange
                };
            }
            if (this.isLiveType) {
                return {
                    spuType: formparam.spuType, // 商品类型
                    categoryId: formparam.categoryId, // 分类
                    name: formparam.name, // 名称
                    headPics: formparam.headPics, // 商品图
                    ...cantChange,
                    skuInfo: JSON.stringify([{
                        salePrice: (Number(formparam.marketPriceValue) * 100).toFixed(), // 价格
                        marketPrice: (Number(formparam.marketPriceValue) * 100).toFixed(), // 价格
                        stockNum: Number(formparam.primaryStock), // 库存
                    }])
                };
            }
            return param;
        },
        // 存草稿/提交的点击
        onClickBtn(formName, ajaxName) {
            // 存草稿无需校验
            // if (ajaxName === 'createSpu') {
            //     this.submitSpu(ajaxName);
            //     this.$refs.form.clearValidate();
            // } else {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitSpu(ajaxName);
                    return;
                }
                this.$message.error('请将信息填写完整');
            });
            // }
        },
        submitSpu(apiName) {
            if (!apiName || !['createSpu', 'submitSpu'].includes(apiName)) {
                return this.$message.error('无效的请求地址');
            }
            const params = this.getData();
            if (this.spuId) {
                params.id = this.spuId;
            }
            this.$api[apiName](params).then(res => {
                // 接口成功做的操作
                if (res.code === 0) {
                    this.$message({
                        message: '恭喜你，提交成功',
                        type: 'success'
                    });
                    this.backList();
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        backList() {
            this.$router.push({
                path: '/commodity/spu-management'
            });
        },
        handleRemove(file, fileList) {
            this.fileList = this.fileList.filter(item => {
                return item.url !== file.url;
            });
            this.fileList.forEach((item, index) => {
                if (item.url === file.url) {
                    delete this.fileList[index];
                }
            });
        },
        // 规格图 删除图片
        handleRemoveStandard(obj, res, file) {
            obj.img = '';
        },
        handlePreview(file) {
            console.log(file);
        },
         // 富文本内容发生改变时
        onEditorChange(event) {
            this.form.detailInfo = event.html;
        },
        handleSuccessQuill(res) {
            // 获取富文本组件实例
            let quill = this.$refs.myQuillEditor.quill;
            let code;
            if (!res.hasOwnProperty('code')) {
                code = res.errno;
            } else {
                code = res.code;
            }
            // 如果上传成功
            if (code === 0) {
                // 获取光标所在位置
                let length = this.$refs.myQuillEditor.quill.selection.savedRange.index;
                // 插入图片  res.info为服务器返回的图片地址
                quill.insertEmbed(length, 'image', res.data.imgUrl);
                // 调整光标到最后
                quill.setSelection(length + 1);
            } else {
                this.$message({
                    message: '图片插入失败',
                    type: 'warning'
                });
            }
        },
        // 预览图片
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
            console.log(file);
        },
        // 商品图 图片上传成功
        handleSuccess(res, file) {
            this.fileList.push({
                url: res.data.imgUrl
            });
            this.form.headPics.push(res.data.imgUrl);
        },
        // 规格图 图片上传成功
        handleSuccessStandard(obj, res, file) {
            obj.img = res.data.imgUrl;
        },
        // 规格图 删除
        deleteStandardImg(obj) {
            obj.img = '';
        },
        handleStandPicSuccess(res, file) {
            // this.form.standardList
        },
        // 超出上传限制数
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制上传9个文件，本次选择了 ${files.length} 个文件`);
        },
        // 图片上传报错
        handleError(err, file, fileList) {
            console.log(err, file, fileList, 123456789)
        },
        // 超出上传限制数
        handleExceedStandard(obj, files, fileList) {
            this.$message.warning(`当前限制上传1个文件，本次选择了 ${files.length} 个文件`);
        },
        // standardlist将后端返回的数据格式转为前端需要的数据格式
        // server的standardValues是'111|222|333', 我们需要的standardValues是[{standardValue: '111', img: ''}]
        serverTransData(standardList = []) {
            // 处理standardValues变成对象
            standardList.forEach(item => {
                if (!item.standardValues) {
                    item.standardValues = [];
                    return standardList;
                }
                item.standardValues = item.standardValues.split('|').map(value => ({
                    standardValue: value,
                    img: ''
                }));
            });
            return standardList;
        },

        async getRemoteStandardList() {
            const res = await this.$api.getRemoteStandardList({categoryId: this.form.categoryId});
            if (+res.code === 0 && res.data) {
                const standardList = res.data || [];
                // 处理standardValues变成对象
                this.remoteStandardList = this.serverTransData(standardList);
            }
        },
        // 获取属性列表
        getPropertyList() {
            this.$api.getPropertyList().then(res => {
                if (0 === +res.code) {
                    this.propertyList = res.data;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.container {
    .title {
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
            .title-logo {
                width: 20px;
                margin-right: 12px;
            }
        }
    }
    .el-form {
        margin-top: 50px;
        width: 97%;
        & > .form-label-title {
            margin-left: 30px;
            border-left: 5px solid blue;
            padding-left: 10px;
            margin-bottom: 20px;
        }
    }
    .el-form-item__content {
        margin-left: 0;
        text-align: center;
    }
    .auto-property {
        background: #F2F2F2;
        border-radius: 6px;
        & > span {
            font-size: 12px;
            color: #666;
            display: block;
            margin-left: 20px;
        }
        & > div {
            display: inline-block;
            margin: 10px 20px;
            .attr-name {
                display: inline-block;
                min-width: 100px;
            }
        }
        .el-input {
            width: 213px;
        }
    }
    .img-upload-tip {
        color: #999;
    }
    .ql-editor {
        min-height: 200px;
    }
    .button-wrapper {
        margin-top: 20px;
        text-align: center;
        .el-button {
            width: 100px;
        }
	}
    .addMerchantProperty {
        color:#007eff;
    }
    .delete {
        font-size: 26px;
        color: #bfb9b9;
        position: absolute;
        right: 2px;
        cursor: pointer;
    }
    .el-form-item-value {
		display: inline-block;
		color: #706969;
    }
    .required {
        color: #F56C6C;
        margin-right: 4px;
    }
    .form-item-row {
        margin-top: 20px;
        &:n-th-of-type(1) {
            margin-top: 0;
        }
    }
    .form-item-row-inline {
      display: inline-block;
      position: relative;
      width: 30%;
      margin-bottom: 20px;
      margin-right: 20px;
      vertical-align: top;
    }
    .sku-attr-wrap {
        width: 500px;
        position: relative;
    }
    /deep/.cell.label-width-red-dot::before,
    .label-width-red-dot::before {
      display: inline-block;
      content: "*";
      color: red;
    }
    .standard-image-wrap {
        img {
            max-width: 148px;
        }
        .delete-icon {
            display: inline-block;
            vertical-align: top;
            font-size: 30px;
            color: gray;
        }
    }
}
</style>
